import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Backdrop,
  CircularProgress,
  Fade,
  Grid,
  Tab,
  Tabs,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { Settings } from '@mui/icons-material';
import { decryptURL } from 'utils/functions';
import { DropsContext } from 'contexts/DropsContext';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import Button from 'components/Button';
import Header from 'components/Header';
import Card from 'components/Card';
import api from 'services/api';
import styles from './styles';

const Anuncio = ({ anuncio, drops, loading, onSubmit }) => {
  const defaultValues = {
    id: anuncio?.id,
    produto_id: anuncio?.produto_id || null,
  };
  const { control, handleSubmit } = useForm({ defaultValues });

  return (
    <Card title="Informações Gerais">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <VirtualDrop
            name="produto_id"
            control={control}
            label="Produto"
            options={drops?.Produto?.filter((f) =>
              [
                '00-Mercadoria para revenda',
                '04-Produto acabado',
                '05-Subproduto',
                '06-Produto intermediário',
              ]?.includes(f?.tipolinha)
            )}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={loading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

const MadeiraMadeira = () => {
  const { hash } = useParams();
  const decrypt = decryptURL(hash);
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [anuncio, setAnuncio] = useState(null);
  const { drops } = useContext(DropsContext);

  const loadData = async () => {
    try {
      setLoading(true);
      const params = {
        id: decrypt?.id,
        integra_access_id: decrypt?.integra_access_id,
      };
      const { data } = await api.get(`/Integracoes/MadeiraMadeira/Anuncio`, {
        params,
      });
      setAnuncio(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    try {
      setPostLoading(true);
      await api.put(`/Integracoes/MadeiraMadeira/Anuncio`, data);
      loadData();
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const tabs = [
    {
      value: 0,
      key: 'Anúncio',
      label: 'Anúncio',
      icon: <Settings />,
    },
  ];

  const RenderTabs = () => {
    if (loading) return null;

    const tabProps = { anuncio, onSubmit, drops, loading: postLoading };

    switch (tab) {
      case 0:
        return <Anuncio {...tabProps} />;
      default:
        return null;
    }
  };

  return (
    <Container>
      <Header titulo="Editar Anúncio" />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <Tabs
              variant="fullWidth"
              value={tab}
              onChange={(_, v) => setTab(v)}
              TabIndicatorProps={styles?.tabProps}
              sx={styles?.tab}
            >
              {tabs.map(({ show = true, ...t }) => show && <Tab {...t} />)}
            </Tabs>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <RenderTabs />
        </Grid>
      </Grid>
      <Fade in={loading}>
        <Backdrop open={loading} sx={styles?.loader}>
          <CircularProgress color="inherit" size={48} thickness={4} />
        </Backdrop>
      </Fade>
    </Container>
  );
};

export default MadeiraMadeira;
